export class Business {
    _id: string;
    id: string;
    name:string;
    phone:string;
    email:string;
    address:string;
    notes:string;
    about: string;
    website: string;
    facebook_url: string;
    linked_url: string;
    created_by: any;
    last_modifiedby: any;
    is_deleted: any;
    is_activated: any;
    admin_notes: string;
    // constructor(obj?: any) {
    //     if (!obj) {
    //         return;
    //     }
    //    this._id = obj._id;
    //    this.id = obj.id;
    //    this.name = obj.name;
    //    this.phone = obj.phone;
    //    this.email = obj.email;
    //    this.address = obj.address;
    //    this.college = obj.college;
    //    this.notes = obj.notes;

    // }
}